import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { BaseComponent } from './_core/components/base.component';
import { GoogleAnalyticsService } from './_modules/analytics/google-analytics.service';
import { HotjarService } from './_modules/analytics/hotjar.service';
import { IntercomService } from './_modules/intercom/intercom.service';
import { VersionCheckService } from './_services/versioning/version-check.service';
import { AuthService } from './_services/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent extends BaseComponent {
    constructor(
        public readonly authService: AuthService,
        private readonly router: Router,
        private readonly gaService: GoogleAnalyticsService, 
        private readonly intercomService: IntercomService,
        private readonly versionChecker: VersionCheckService,
        private readonly hotjar:HotjarService) {
        super(); 
        
        this.gaService.initialize(this.router);
        this.intercomService.initialize(this.router);
        this.hotjar.initialize(this.router)

        this.versionChecker.runCheckVersion(1000 * 5);
    }

    @HostListener('document:visibilitychange')
    public onVisibilityChange(): void {
        if (document.visibilityState === 'hidden') {
            this.authService.markSessionAway();
        } else {
            this.authService.resumeSession();
        }
    }

    @HostListener('window:blur')
    public onWindowBlur(): void {
        this.authService.markSessionAway();
    }

    @HostListener('window:focus')
    @HostListener('window:pageshow')
    public onWindowReturn(): void {
        if (document.visibilityState === 'visible') {
            this.authService.resumeSession();
        }
    }

    /* @HostListener('window:beforeunload', ['$event'])
    public beforeunloadHandler(_): void {
        this.authService.destroySession();
    } */
}
